export const isKnownRoute = (pathname) => {
  const staticPaths = ['/', '/about', '/team', '/services', '/portfolio', '/contact', '/404'];
  if (staticPaths.includes(pathname)) return true;
  if (/^\/project\/\d+$/.test(pathname)) return true;
  if (/^\/services\/\d+$/.test(pathname)) return true;
  return false;
};
